import { formatDate, parsePaymentDate } from "../../utils/date";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const columnsData = [
  {
    field: "name",
    headerName: "Kid Name",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "full_name",
    headerName: "Mentor Name",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      return <>{!params.row.mentor_id ? "Anonymous" : params.row.full_name}</>;
    },
  },
  {
    field: "email",
    headerName: "Mentor Email",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "mobile_no",
    headerName: "Mentor Mobile",
    renderCell: (params) => {
      return (
        <div>
          {params.row.mobile_no
            ? params.row.mobile_no
            : params.row.anonymous_mobile_no}
        </div>
      );
    },
    flex: 1,
    minWidth: 120,
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "for_months",
    headerName: "For Months",
    flex: 1,
    minWidth: 90,
  },
  {
    field: "category_name",
    headerName: "Category",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "is_active",
    headerName: "Status",
    flex: 1,
    minWidth: 90,
    renderCell: (params) => {
      return (
        <div
          className={
            params.row.is_active
              ? "statusBadge status-active"
              : "statusBadge status-cancelled"
          }
        >
          {params.row.is_active ? "Active" : "Inactive"}
        </div>
      );
    },
  },
  {
    field: "mentored_on_date",
    headerName: "Mentored Date",
    flex: 1,
    minWidth: 120,
    sortable: true,
    valueGetter: (params) =>
      parsePaymentDate(params.row.mentored_on_date).getTime(),
    sortComparator: (v1, v2) => v2 - v1,
    renderCell: (params) => {
      return <div>{formatDate(params.row.mentored_on_date)}</div>;
    },
  },
];

let actionHeader = (handleDelete, onHistoy, sponsorHistoy) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      maxWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Delete sponsorship"
              onClick={() => handleDelete(params.row)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
            {sponsorHistoy.some((s) => params.row.kid_id === s.kid_id) && (
              <ActionIconButton
                title="Sponsor history"
                onClick={() => onHistoy(params.row.kid_id)}
              >
                <HistoryRoundedIcon fontSize="small" />
              </ActionIconButton>
            )}
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
